//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../common/helpers/HttpHelper'
import environments from '../common/environments/environment';
const http = new httpHelper();


export const UserDetailsActions = {
    GetCreateNewUserJSON: getCreateNewUserJSON,
    GetUserDetails: getUserDetails,
    GetUserRole: getUserRole,
    GetLanguage: getLanguage,
    CreateNewUser: createNewUser,
    TrackAction: trackAction,
    GetTimeZone: getTimeZone,
    GetUserDetailsByStaffId: getUserDetailsByStaffId,
    GetCronofyTimeZone: getCronofyTimeZone,
    GetCronofyServiceAccount: getCronofyServiceAccount,
    UpdateUserDetails: updateUserDetails
}
function trackAction(payload) {
    return http.adminPost(environments.TRACK_ADMIN_ACTIONS, payload);
}

function getCreateNewUserJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.CREATE_NEW_USER_JSON);
}

function getUserDetails(activeEmail) {
    return http.graphUserApiGet(activeEmail);
}

function getUserDetailsByStaffId(staffId) {
    return http.adminGet(environments.GET_USER_DETAILS_BY_STAFF_ID.replace("{id}", staffId));
}

function updateUserDetails(payload) {
    return http.adminPut(environments.UPDATE_USER_DETAILS, payload);
}

function getCronofyTimeZone(countryCode) {
    return http.adminGet(environments.GET_CRONOFY_TIMEZONE.replace("{countryCode}", countryCode));
}

function getCronofyServiceAccount() {
    return http.adminGet(environments.GET_CRONOFY_SERVICE_ACCOUNT);
}

function getUserRole() {
    return http.adminGet(environments.USER_ROLE);
}

function getLanguage(countryCode) {
    let refRole = environments.USER_LANGUAGE.replace("{countryCode}", countryCode)
    return http.adminGet(refRole);
}

function createNewUser(payload) {
    return http.adminPost(environments.CREATE_NEW_USER, payload);
}

function getTimeZone(language) {
    return http.getTimezoneData(environments.TIMEZONE.replace('{lang}', language));
}
